import React, { useEffect, useRef, useState } from 'react';
import './HowItWorks.css';

const steps = [
  {
    number: '01',
    icon: '✦',
    image: `${process.env.PUBLIC_URL}/step1-questions.jpg`,
    title: 'Answer 13 Questions',
    description: 'No birth chart jargon. Just honest questions about how you think, love, fight, and dream. Five minutes is all it takes.',
    detail: 'An original self-reflection questionnaire',
  },
  {
    number: '02',
    icon: '🔮',
    image: `${process.env.PUBLIC_URL}/step2-blueprint.jpg`,
    title: 'Explore Your Soul Profile',
    description: 'Your natal chart meets your personality. 10 core attributes revealed. Your archetype named. Your AI avatar forged from the stars.',
    detail: 'Powered by real astrology + AI',
  },
  {
    number: '03',
    icon: '⚡',
    image: `${process.env.PUBLIC_URL}/step3-transform.jpg`,
    title: 'Practice, Reflect & Connect',
    description: 'Explore reflective practices, understand relationships in Circle, and revisit your personal Journey. The Oracle draws on your profile and the context you choose to share.',
    detail: 'Your journey starts the moment you begin',
  },
];

const HowItWorks: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="how-it-works" id="how-it-works" ref={sectionRef}>
      <div className="hiw-container">
        <p className="hiw-eyebrow">How It Works</p>
        <h2 className="hiw-title">Three Steps to Knowing Your Soul</h2>
        
        <div className="hiw-steps">
          {steps.map((step, i) => (
              <div key={i}
                className={`hiw-step ${visible ? 'hiw-step-visible' : ''}`}
                style={{ transitionDelay: `${i * 0.2}s` }}
              >
                <div className="hiw-step-glow" />
                {/* number removed */}
                <div className="hiw-step-icon-wrap">
                  {step.image ? (
                    <img src={step.image} alt={step.title} className="hiw-step-image" />
                  ) : (
                    <>
                      <div className="hiw-step-icon-bg" />
                      <span className="hiw-step-icon">{step.icon}</span>
                    </>
                  )}
                </div>
                <h3 className="hiw-step-title">{step.title}</h3>
                <p className="hiw-step-desc">{step.description}</p>
                <span className="hiw-step-detail">{step.detail}</span>
              </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
